
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.478 47.8v-.3-1-13-.9V30c-.2-2.7-1.9-4.4-2.3-6.9-.4-4.6-.7-9.2-1.1-13.9.5-.4.4-2.1-.2-2.2 0-.3 0-.6-.1-.8.7-.6.6-3.2-.2-3.2H27.078c-.9 0-1 2.6-.2 3.1v.8c-.8 0-.8 2.1-.2 2.2-.2 4.6-.2 9.4-1.2 13.8-.7 3.2-2.3 5.4-2.3 8.7V43.7c0 2.9-.4 6.1 0 9 .5 3.9 3.2 3.3 6.4 3.3 2.1 0 5.7.8 7.2-1 1.3-1.5.7-5.3.7-7.2zm-12.9-2.3v-9.4-1.6h11.6v10.9c-3.9.1-7.8.1-11.6.1zm3.6-39.3h4.2c0 .2 0 .5.1.7h-4.2c-.1-.3-.1-.5-.1-.7zm-1.6 19.1c.9-2.9.7-6.4.9-9.5.2-2.2.3-4.4.5-6.7h4.6c.4 4.8.8 9.5 1.1 14.3v.4c0 .4.1.7.2.8.6 1.9 1.8 3.5 2.1 5.5.1.4.1.9.1 1.3h-11.7v-.7c.4-2.1 1.6-3.5 2.2-5.4zm9.5 27.3c-.6.8-4.5.3-5.6.3-1.4 0-3.5.4-4.8 0-1.7-.6-1.2-.9-1.2-2.8v-1.4h11.6c.1 1 .4 3.3 0 3.9z"}})])
          )
        }
      }
    